import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import store, { history } from './store'

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import ReduxToastr from 'react-redux-toastr'

import {App} from './app'


// import 'sanitize.css/sanitize.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/css/bootstrap-rtl.css'
// import 'font-awesome/css/font-awesome.min.css'
import '@mdi/font/css/materialdesignicons.min.css'
// import './assets/css/ecoat-icons.css'

// import './assets/css/material-dashboard.css'
import './assets/css/leaflet.css'
// import './assets/css/indicator.css'
// import './assets/css/main.css'

// import './assets/js/jquery-2.2.4.min.js'
// import './assets/js/bootstrap.min.js'
// import './assets/js/material-dashboard.js'

const target = document.querySelector('#root')

render(
  <Provider store={store}>
    <div>
      <ConnectedRouter history={history}>
        <div>
          <App />
        </div>
      </ConnectedRouter>
      <ReduxToastr
        timeOut={5000}
        newestOnTop={false}
        preventDuplicates
        position="top-left"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick
      />
    </div>
  </Provider>,
  target
)
